var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoins = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.744 17.736a6 6 0 1 1-7.48-7.48"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 6h1v4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m6.134 14.768.866-.5 2 3.464"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 8,
  r: 6
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoins);
export { ForwardRef as ReactComponent };